import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationPT from './locales/pt.json';
import translationES from './locales/es.json';
import translationEN from './locales/en.json';

const resources = {
  pt: { translation: translationPT },
  es: { translation: translationES },
  en: { translation: translationEN }
};

// Detectar idioma inicial SEM flash e SEM localStorage:
// O localStorage causava bug cross-session: usuário BR abria sem VPN (salva 'pt'),
// depois abria com VPN US → localStorage retornava 'pt' → geoloc muda para EN = misturado
// A geolocalização (useLanguageDetection) sempre corrige o idioma após ~300ms
function getInitialLanguage() {
  // Limpar cache stale do i18next (correção para usuários com valor antigo salvo)
  try { localStorage.removeItem('i18nextLng'); } catch (_) {}

  const browserLang = (navigator.language || navigator.userLanguage || 'pt').toLowerCase();
  if (browserLang.startsWith('pt')) return 'pt';
  if (browserLang.startsWith('es')) return 'es';
  if (browserLang.startsWith('en')) return 'en';

  return 'pt'; // Fallback: maioria dos usuários é brasileira
}

const initialLanguage = getInitialLanguage();
console.log('🌐 Idioma inicial:', initialLanguage, '| Navegador:', navigator.language);

// Inicializar i18n de forma síncrona
// NÃO usar LanguageDetector — o app usa useLanguageDetection (geolocalização) para isso.
// LanguageDetector com caches:['localStorage'] causava contaminação cross-session de idioma.
const i18nInstance = i18n.createInstance();

i18nInstance
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage,       // Idioma imediato (sem flash), baseado no browser
    fallbackLng: 'pt',          // Fallback para português
    supportedLngs: ['pt', 'es', 'en'],

    interpolation: {
      escapeValue: false // React já faz escape
    },

    react: {
      useSuspense: false,
      bindI18n: 'languageChanged',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i']
    },

    debug: false,
    initImmediate: false,
    returnEmptyString: false,
    returnNull: false,
    saveMissing: false,
    updateMissing: false
  });

export default i18nInstance;
